import { StyleSheet } from 'aphrodite/no-important';

export const sidebarStyles = StyleSheet.create({
    sideBar: {
       "@media (min-width: 768px)": {
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
        },
        zIndex: 100,
        padding: "60px 0 0",
        boxShadow: "inset -1px 0 0 rgb(0, 0, 0, .1)",
    },
    sideBarSticky: {
        //768px is bootstrap sm
        "@media (min-width: 768px)": {
            position: "relative",
            top: 0,
            height: "calc(100vh - 48px)",
            paddingTop: "0rem",
            overflowX: "hidden",
            overflowY: "auto",
        }
    },
    title: {
        color: "#fff",
    },
    sideBarStickyWebkit: {
        "@supports (position: sticky)": {
            position: "sticky",
        },
        "@supports (position: -webkit-sticky)": {
            position: "-webkit-sticky",
        },
    },
    link: {
        color: "#fff",
        fontWeight: 500,
        ":hover": {
            color: "#fff",
        }
    },
    icon: {
        color: "#fff",
        marginRight: "4px",
        verticalAlign: "text-top",
    },
    hover: {
        ":hover .feather": {
            color: "inherit",
        }
    },
    toggle: {
        margin:"15px 5px 0px 0px",
    },
    toggleIcon: {
        verticalAlign:"text-top",
    },
});

export const navbarStyles = StyleSheet.create({
    navbar: {
        padding: 15,
        color: "#fff",
        height: "60px",
    },
    logo: {
        maxWidth:"100px",
    },
    navbar_dropdown: {
        padding: "0px !important",
        marginRight: "10px !important",
        color:"#fff",
        ":hover": {
            color:"#fff !important",
        }
    }
});

export const contentStyles = StyleSheet.create({
    contentCol: {
        marginTop: "75px",
        padding: "3vh 3vw",
        backgroundColor: "#fff",
    }
});

export const panelStyles = StyleSheet.create({
    item: {
        padding: "10px 15px ",
        margin: "2.5px 5px 2.5px 5px",
    },
    panelTitle: {
        fontSize: "13px",
        fontWeight: "300",
        color: "#fff",
    },
    number:{
        fontSize: "33px",
        color: "#fff",
        fontWeight: 300,
        textDecoration: "underline",
    }

});



// WEBPACK FOOTER //
// ./src/Components/App/Layout/styles.js